module.exports = __webpack_public_path__ + "img/fund-map-hero.f1953fb7.png";